import { render, staticRenderFns } from "./app-update-modal.vue?vue&type=template&id=2d8af376&scoped=true&"
import script from "./app-update-modal.vue?vue&type=script&lang=js&"
export * from "./app-update-modal.vue?vue&type=script&lang=js&"
import style0 from "./app-update-modal.vue?vue&type=style&index=0&id=2d8af376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8af376",
  null
  
)

export default component.exports